import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { FC } from 'react';

interface DeleteButtonProps {
  onClickDelete: () => void;
  fontSize?: string;
}

const defaultProps = { fontSize: '25px' };

const DeleteButton: FC<DeleteButtonProps> = ({ onClickDelete, fontSize }) => (
  <Tooltip title="Delete dashboard">
    <IconButton size="small" onClick={onClickDelete} aria-label="Delete dashboard">
      <span style={{ fontSize }}>
        <Icon iconId="delete" />
      </span>
    </IconButton>
  </Tooltip>
);

DeleteButton.defaultProps = defaultProps;

export default DeleteButton;
